<template functional>
    <router-link
        :to="props.link"
        v-bind="$attrs"
        tag="div"
        class="subtle-link"
    >
        <span class="subtle-link__text">
            <slot />
        </span>
        <i class="icon subtle-link__icon icon-arrow_right"/>
    </router-link>
</template>

<script>
    import Vue from 'vue';

    export default Vue.component('SubtleLink', {
        functional: true,
        name: 'SubtleLink',
        props: {
            link: {
                type: [Object, String],
                required: true,
            }
        },
    });
</script>


// WEBPACK FOOTER //
// src/app/modules/shared/components/SubtleLink.vue